module.exports = __webpack_public_path__ + "img/bg.5b0b5027.png";